<template>
    <div class="app-wrapper">
        <Sidebar />
        <div class="main-container">
            <Navbar/>    
            <App-main/>
        </div>
    </div>
</template>

<script>
    import { Navbar, Sidebar, AppMain } from 'views/layout';

    export default {
      name: 'layout',
      components: {
        Navbar,
        Sidebar,
        AppMain
      },
      computed: {

      }
    }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    @import "src/styles/mixin.scss";

    .app-wrapper {
        @include clearfix;
        position: relative;
        width: 100%;
        height: 100vh;
        .main-container {
            transition: all .28s ease-out;
            position: relative;
            margin-left: 160px;
        }
    }
</style>



// WEBPACK FOOTER //
// Layout.vue?5560a79e